import React, { memo, forwardRef } from 'react';
import { AlertIcon } from '@gwc/icons';
import { Text } from '../slots/Text';
import { Trails } from '../slots/Trail';
import { Typography } from '../typography';
import { Box } from '../box';
import { TextInput } from '../text-input';
import { Select, Clear, Toggle } from './Select';
import { Leads } from '../slots/Lead';
import styles from './styles.module.css';
export const Simple = memo(forwardRef(function Simple({ label, value, iconStart, clearable, ...props }, ref) {
    const multiSelectText = Array.isArray(value) ? value.map(x => x.value).join(', ') : null;
    return (React.createElement(Select, { "aria-label": typeof label === 'string' ? label : undefined, ...props, value: value, ref: ref }, ({ labelProps, inputProps, error }) => (React.createElement(React.Fragment, null,
        !!iconStart && React.createElement(Leads.Icon, null, iconStart),
        React.createElement(Text, null,
            !!label && React.createElement(Typography, { ...labelProps }, label),
            React.createElement(Typography, { variant: inputProps.variant, Component: "span", className: styles.multiValueWrap },
                multiSelectText && (React.createElement(Box, { Component: "span", flexShrink: 0, mr: "xs", className: styles.multiValue }, multiSelectText)),
                React.createElement(TextInput, { ...inputProps, className: styles.input }))),
        clearable !== false && React.createElement(Clear, null),
        error ? (React.createElement(Trails.Icon, { color: "error" },
            React.createElement(AlertIcon, null))) : (React.createElement(Toggle, null))))));
}));
export const Single = memo(forwardRef(function Single(props, ref) {
    return React.createElement(Simple, { ...props, multi: false });
}));
export const Multi = memo(forwardRef(function Single(props, ref) {
    return React.createElement(Simple, { ...props, multi: true });
}));
